import { render, staticRenderFns } from "./pushMsgForm.vue?vue&type=template&id=310afe3f&scoped=true"
import script from "./pushMsgForm.vue?vue&type=script&lang=js"
export * from "./pushMsgForm.vue?vue&type=script&lang=js"
import style0 from "./pushMsgForm.vue?vue&type=style&index=0&id=310afe3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310afe3f",
  null
  
)

export default component.exports